<template>
  <div>
    <CAP0540_co :key="componentKey" @reload="forceReload"/>
  </div>
</template>

<script>
import CAP0540_co from './CAP0540_co.vue'

export default {
  name: "MENU_CAP0560",
  components: {
    CAP0540_co
  },
  data() {
    return {
      componentKey: 0
    };
  },
  methods: {
    forceReload() {
      this.componentKey += 1;
    }
  }
}
</script>
